


import * as XLSX from "xlsx";
import { Grid, Stack, Pagination, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import useEncryption from "EncryptDecrypt/EncryptDecrypt";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstanceAuth } from "apiInstances";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import { FaDownload } from "react-icons/fa6";
const ABNWithdrawRecords = () => {
  let navigate = useNavigate();
  const [requestData, setRequestData] = useState([]);
  console.log("🚀 ~ ABNWithdrawRecords ~ requestData:", requestData)
  const [oldRequestData, setOldRequestData] = useState([]);
  console.log("🚀 ~ ABNWithdrawRecords ~ oldRequestData:", oldRequestData)

  const { encryptData, decryptData } = useEncryption();
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);

  const [page, setPage] = useState(1);

  const checkToken = () => {
    const Token = localStorage.getItem("Token");
    if (!Token) {
      navigate("/sign-in");
    }
  };

  const getWithdrawRecords = async () => {
    try {
      await axiosInstanceAuth
        .get(`/admin/abnwithdrawHistory`)
        .then((res) => {
          const responseData = decryptData(res.data.data);


          if (responseData.status) {
            setPage(Math.ceil(res.data.count / 10));
            responseData?.data?.sort((a, b) => {
              return new Date(b.createdAt) - new Date(a.createdAt);
            })
            const temp = [];
            responseData.data.map((data, index) => {
              temp.push({
                id: (
                  <MDTypography component="a" variant="button" color="text" fontWeight="medium">
                    {index + 1}
                  </MDTypography>
                ),
                name: (
                  <MDTypography component="a" variant="button" color="text" fontWeight="medium">
                    {`${data.username}`}
                  </MDTypography>
                ),
                ABN_Withdrawn_From: (
                  <MDTypography component="a" variant="button" color="text" fontWeight="medium">
                    {data.WithdrawName}
                  </MDTypography>
                ),
                ABN_Withdraw_Amount: (
                  <MDTypography component="a" variant="button " color="text" fontWeight="medium">
                    {data?.WithdrawrewardsAmount}
                  </MDTypography>
                ),
                address: (
                  <MDTypography component="a" variant="button " color="text" fontWeight="medium">
                    {data?.address}
                  </MDTypography>
                ),

                Date: (
                  <MDTypography component="a" variant="button" color="text" fontWeight="medium">
                    {new Date(data.createdAt.toString()).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      }
                    )}
                  </MDTypography>
                ),
              });
            });

            setRequestData(temp);
            setOldRequestData(temp);
            setLoading(false);
          }
        })
        .catch((res) => {
          toast.error(res.data.message);
        });
    } catch (error) {
      console.log("🚀 ~ getUser ~ error:", error);
    }
  };

  const handleInput = (e) => {
    if (e.target.value) {
      const searchData = oldRequestData.filter((i) => {
        return (
          i?.name?.props?.children
            ?.toLowerCase()
            .trim()
            .includes(e.target.value.toLowerCase().trim()) ||
          i?.address?.props?.children
            ?.toString()
            ?.toLowerCase()
            .trim()
            .includes(e.target.value.toLowerCase().trim())
        );
      });

      setRequestData(searchData);
    } else {
      setRequestData(oldRequestData);
    }
  };

  useEffect(() => {
    checkToken();
    getWithdrawRecords();
  }, []);

  const columns = [
    { Header: "id", accessor: "id", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "ABN Withdrawn From", accessor: "ABN_Withdrawn_From", align: "left" },
    { Header: "ABN Withdraw Amount", accessor: "ABN_Withdraw_Amount", align: "left" },
    { Header: "address", accessor: "address", align: "left" },
    { Header: " Date", accessor: "Date", align: "left" },
  ];

  const onPaginationTable = () => {
    getWithdrawRecords();
  };
  const downloadReport = async () => {
    setLoading1(true);
    try {
      const encryptedData = encryptData();
      await axiosInstanceAuth
        .get(`/admin/abnwithdrawHistory`, {
          data: encryptedData,
        })
        .then((res) => {
          const responseData = decryptData(res.data.data);
          console.log("🚀 ~ file: index.js:159 ~ .then ~ responseData:", responseData);
          const formattedData = responseData.data.map((data) => ({
            name: data.username,
            ABN_Withdrawn_From: data.WithdrawName,
            ABN_Withdraw_Amount: data.WithdrawrewardsAmount,
            address: data.address,
            Date: new Date(data.createdAt.toString()).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "short",
                day: "numeric",
              }
            )
          }));
          const workSheet = XLSX.utils.json_to_sheet(formattedData);
          const workBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workBook, workSheet, "users");
          //Buffer
          let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
          //Binary string
          XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
          //Download
          XLSX.writeFile(workBook, "withdrawRewards.xlsx");
          setLoading1(false);
        })
        .catch((res) => {
          toast.error(res.data.message);
        });
    } catch (error) { }
  };
  return (
    <>
      <DashboardNavbar />
      <DashboardLayout>
        {loading ? (
          <div className="snippet" data-title=".dot-spin">
            <div className="stage">
              {/* {loading1 ? (
                <div className="dot-spin-container">
                  <div className="dot-spin1"></div>
                  <div className="dot-spin-text">Downloading file </div>
                </div>
              ) : ( */}
              <div className="dot-spin"></div>
              {/* )} */}
            </div>
          </div>
        ) : (
          <MDBox pt={6} pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="coinTitleColor"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <div className="box-user ">
                      <MDTypography variant="h6" color="white">
                        ABN Withdraw Commissions History
                      </MDTypography>
                      {loading1 ? (
                        <>
                          <div className="flex justify-center items-center gap-2">
                            <div className="dot-spin1"></div>
                            <MDButton
                              onClick={downloadReport}
                              variant="contained"
                              color="info"
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              Downloading ..
                            </MDButton>
                          </div>
                        </>
                      ) : (
                        <>

                          <MDButton
                            onClick={downloadReport}
                            variant="contained"
                            color="info"
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <FaDownload className="mr-3" /> Withdraw Rewards
                          </MDButton>

                        </>
                      )}
                    </div>
                  </MDBox>
                  <MDBox pt={3}>
                    <MDBox pr={1} classNane="inputsre">
                      <TextField type="text" label="Search here" onChange={handleInput} />
                    </MDBox>
                    <DataTable
                      table={{ columns: columns, rows: requestData }}
                      // isSorted={true}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                    {/* {requestData.length > 0 && (
                      <Stack padding={2}>
                        <Pagination onChange={onPaginationTable} count={page} size="large" />
                      </Stack>
                    )} */}
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        )}
        <Footer />
      </DashboardLayout>
    </>
  );
};

export default ABNWithdrawRecords;
